// 正式
module.exports = {
  title: '检测',
  baseUrl: 'https://wx-applets.smart-info.cn',
  // 正式项目地址
  baseApi: 'https://wx-applets.smart-info.cn/crg/wxa/resourceDetect',
  // 正式api请求地址
  APPID: 'wxe125adaff392529f' // 云上书院appid

};